import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import OutOfStock from './OutOfStock/OutOfStock';

export const StockStatus = ({ stockStatus, alignCenter, classes }) => {
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	if (!stockStatus) {
		return null;
	}

	if (stockStatus === 'OutOfStock') {
		return (
			<OutOfStock
				classes={classnames({
					'mt-4 mb-auto': !CustomCategoriesEnabled,
				})}
			/>
		);
	}

	return null;
};

export default StockStatus;
